(function () {
  // Class name used to hide selling plan elements
  const hiddenClass = "selling_plan_theme_integration--hidden";

  // Check if SellingPlansWidget is already defined
  if (typeof SellingPlansWidget === "undefined") {
    // Define the SellingPlansWidget class
    class SellingPlansWidget {
      constructor(sellingPlansWidgetContainer) {
        console.log("Initializing SellingPlansWidget");
        this.sellingPlansWidgetContainer = sellingPlansWidgetContainer;
        this.sectionId =
          this.sellingPlansWidgetContainer.getAttribute("data-section-id");
        // Find the closest element with the data-product-form-regular attribute
        this.shopifySection = this.sellingPlansWidgetContainer.closest(
          "[data-product-form-regular]",
        );

        // If the shopifySection is not found, log an error and return
        if (!this.shopifySection) {
          console.error("Shopify section not found:", this.sectionId);
          return;
        }

        // Initialize various functionalities
        this.enablePerformanceObserver();
        this.appendSellingPlanInputs();
        this.updateSellingPlanInputsValues();
        this.listenToVariantChange();
        this.listenToSellingPlanFormRadioButtonChange();
        this.updatePrice();
        this.updateSubscriptionOfferMessageVisibility();
      }

      // Get the variant ID input element
      get variantIdInput() {
        const input =
          this.addToCartForms[1]?.querySelector(`input[name="id"]`) ||
          this.addToCartForms[1]?.querySelector(`select[name="id"]`) ||
          this.addToCartForms[0]?.querySelector(`input[name="id"]`) ||
          this.addToCartForms[0]?.querySelector(`select[name="id"]`);
        console.log("Variant ID input:", input);
        return input;
      }

      // Get the current price element
      get priceElement() {
        const priceElement = this.shopifySection?.querySelector(
          ".price__current .money",
        );
        console.log("Price element:", priceElement);
        return priceElement;
      }

      // Get the compared at price element
      get comparedAtPriceElement() {
        const comparedAtPriceElement = this.shopifySection?.querySelector(
          ".price__compare-at .money",
        );
        console.log("Compared at price element:", comparedAtPriceElement);
        return comparedAtPriceElement;
      }

      // Get the visible selling plan form for the selected variant
      get visibleSellingPlanForm() {
        const form = this.shopifySection?.querySelector(
          `section[data-variant-id^="${this.variantIdInput?.value}"]`,
        );
        console.log("Visible selling plan form:", form);
        return form;
      }

      // Check if the variant is available
      get isVariantAvailable() {
        const available = this.selectedPurchaseOption
          ?.getAttributeNames()
          .includes("disabled");
        console.log("Is variant available:", available);
        return available;
      }

      // Get the hidden input element that stores the selected selling plan ID
      get sellingPlanInput() {
        const input = this.shopifySection?.querySelector(
          ".selected-selling-plan-id",
        );
        console.log("Selling plan input:", input);
        return input;
      }

      // Get all add-to-cart forms in the shopifySection
      get addToCartForms() {
        const forms =
          this.shopifySection?.querySelectorAll('[action*="/cart/add"]') || [];
        console.log("Add to cart forms:", forms);
        return forms;
      }

      // Append the selling plan input to each add-to-cart form
      appendSellingPlanInputs() {
        console.log("Appending selling plan inputs");
        this.addToCartForms.forEach((addToCartForm) => {
          addToCartForm.appendChild(this.sellingPlanInput.cloneNode());
          console.log("Appended selling plan input to form:", addToCartForm);
        });
      }

      // Show the selling plan form for the selected variant
      showSellingPlanForm(sellingPlanFormForSelectedVariant) {
        if (sellingPlanFormForSelectedVariant) {
          console.log("Showing selling plan form for selected variant");
          sellingPlanFormForSelectedVariant.classList.remove(hiddenClass);
        }
      }

      // Hide all other selling plan forms
      hideSellingPlanForms(sellingPlanFormsForUnselectedVariants) {
        sellingPlanFormsForUnselectedVariants.forEach((element) => {
          console.log("Hiding selling plan form for unselected variant");
          element.classList.add(hiddenClass);
        });
      }

      // Handle the visibility of the selling plan forms based on the selected variant
      handleSellingPlanFormVisibility() {
        console.log("Handling selling plan form visibility");
        const sellingPlanFormForSelectedVariant =
          this.shopifySection?.querySelector(
            `section[data-variant-id="${this.variantIdInput?.value}"]`,
          );
        const sellingPlanFormsForUnselectedVariants =
          this.shopifySection?.querySelectorAll(
            `.selling_plan_theme_integration:not([data-variant-id="${this.variantIdInput?.value}"])`,
          ) || [];
        this.showSellingPlanForm(sellingPlanFormForSelectedVariant);
        this.hideSellingPlanForms(sellingPlanFormsForUnselectedVariants);
      }

      // Handle changes when a different variant is selected
      handleVariantChange() {
        console.log("Handling variant change");
        this.handleSellingPlanFormVisibility();
        this.updateSellingPlanInputsValues();
        this.listenToSellingPlanFormRadioButtonChange();
        this.updatePrice();
        this.updateSubscriptionOfferMessageVisibility();
      }

      // Listen for changes to the variant selection
      listenToVariantChange() {
        console.log("Listening to variant change");
        this.listenToAddToCartForms();
        if (this.variantIdInput?.tagName === "INPUT") {
          const variantIdObserver = new MutationObserver((mutationList) => {
            mutationList.forEach((mutationRecord) => {
              this.handleVariantChange(mutationRecord.target.value);
            });
          });

          variantIdObserver.observe(this.variantIdInput, {
            attributes: true,
          });
        }
      }

      // Listen for changes to the add-to-cart forms
      listenToAddToCartForms() {
        console.log("Listening to add-to-cart forms");
        this.addToCartForms.forEach((addToCartForm) => {
          addToCartForm.addEventListener("change", () => {
            console.log("Variant change detected in add-to-cart form");
            this.handleVariantChange();
          });
        });
      }

      // Get all selling plan inputs
      get sellingPlanInputs() {
        const inputs =
          this.shopifySection?.querySelectorAll(".selected-selling-plan-id") ||
          [];
        console.log("Selling plan inputs:", inputs);
        return inputs;
      }

      // Update the values of the selling plan inputs
      updateSellingPlanInputsValues() {
        console.log("Updating selling plan input values");
        this.sellingPlanInputs.forEach((sellingPlanInput) => {
          sellingPlanInput.value = this.sellingPlanInputValue;
          console.log(
            "Updated selling plan input value:",
            sellingPlanInput.value,
          );
        });
      }

      // Get the value of the selected selling plan input
      get sellingPlanInputValue() {
        const value =
          this.selectedPurchaseOption?.dataset.sellingPlanId ?? null;
        console.log("Selling plan input value:", value);
        return value;
      }

      // Get the currently selected purchase option
      get selectedPurchaseOption() {
        const option = this.visibleSellingPlanForm?.querySelector(
          'input[type="radio"]:checked',
        );
        console.log("Selected purchase option:", option);
        return option;
      }

      // Set the currently selected purchase option
      set selectedPurchaseOption(selectedPurchaseOption) {
        this._selectedPurchaseOption = selectedPurchaseOption;
      }

      // Handle changes to the radio button selection
      handleRadioButtonChange(selectedPurchaseOption) {
        console.log("Handling radio button change");
        this.selectedPurchaseOption = selectedPurchaseOption;
        this.updateSellingPlanInputsValues();
        this.updatePrice();
        this.updateSubscriptionOfferMessageVisibility();
      }

      // Show the offer message only when a subscription option is selected
      updateSubscriptionOfferMessageVisibility() {
        const messageEl = this.visibleSellingPlanForm?.querySelector(
          "[data-subscription-offer-message]",
        );
        if (!messageEl) return;

        const isSubscriptionSelected =
          this.selectedPurchaseOption?.dataset?.radioType === "selling_plan";
        messageEl.hidden = !isSubscriptionSelected;
      }

      // Listen for changes to the selling plan form radio buttons
      listenToSellingPlanFormRadioButtonChange() {
        console.log("Listening to selling plan form radio button change");
        this.visibleSellingPlanForm
          ?.querySelectorAll('input[type="radio"]')
          .forEach((radio) => {
            radio.addEventListener("change", (event) => {
              console.log("Selling plan form radio button change detected");
              this.handleRadioButtonChange(event.target);
            });
          });
      }

      // Update the price display based on the selected purchase option
      updatePrice() {
        if (!this.selectedPurchaseOption) return;

        console.log("Updating price");
        const priceElement = this.priceElement;
        const comparedAtPriceElement = this.comparedAtPriceElement;

        let variantPrice =
          this.selectedPurchaseOption.dataset.variantPrice.replace(" GBP", "");
        let variantComparedAtPrice =
          this.selectedPurchaseOption.dataset.variantCompareAtPrice.replace(
            " GBP",
            "",
          );

        if (!variantPrice.startsWith("£")) {
          variantPrice = "£" + variantPrice;
        }
        if (!variantComparedAtPrice.startsWith("£")) {
          variantComparedAtPrice = "£" + variantComparedAtPrice;
        }

        if (priceElement) {
          priceElement.textContent = variantPrice;
        }
        if (comparedAtPriceElement) {
          comparedAtPriceElement.textContent = variantComparedAtPrice;
        }

        if (
          !variantComparedAtPrice ||
          variantComparedAtPrice === variantPrice
        ) {
          if (priceElement) {
            priceElement.textContent = variantPrice;
          }
          if (comparedAtPriceElement) {
            comparedAtPriceElement.style.display = "none";
          }
          priceElement.closest(".price").classList.remove("price--on-sale");
        } else {
          if (priceElement) {
            priceElement.textContent = variantPrice;
          }
          if (comparedAtPriceElement) {
            comparedAtPriceElement.textContent = variantComparedAtPrice;
            comparedAtPriceElement.style.display = "block";
          }
          priceElement.closest(".price").classList.add("price--on-sale");
        }
      }

      // Enable performance observer to monitor network requests
      enablePerformanceObserver() {
        console.log("Enabling performance observer");
        const performanceObserver = new PerformanceObserver((list) => {
          list.getEntries().forEach((entry) => {
            if (entry.initiatorType !== "fetch") return;

            const url = new URL(entry.name);
            if (
              url.search.includes("variant") ||
              url.search.includes("variants")
            ) {
              this.updatePrice();
            }
          });
        });

        performanceObserver.observe({ entryTypes: ["resource"] });
      }
    }

    // Initialize SellingPlansWidget for each container on the page when DOM content is fully loaded
    document.addEventListener("DOMContentLoaded", () => {
      console.log("DOMContentLoaded event");
      initializeSellingPlansWidgets();
    });

    // Initialize selling plans widgets function
    function initializeSellingPlansWidgets() {
      console.log("Initializing selling plans widgets");
      document
        .querySelectorAll(".selling_plan_app_container")
        .forEach((sellingPlansWidgetContainer) => {
          new SellingPlansWidget(sellingPlansWidgetContainer);
        });
    }

    // Event listener for opening the product modal
    document.addEventListener("click", (event) => {
      if (event.target.matches(".open-modal-button")) {
        const productId = event.target.dataset.productId;
        openProductModal(productId);
      }
    });

    // Function to open product modal and load content
    function openProductModal(productId) {
      console.log("Opening product modal for product ID:", productId);
      fetch(`/products/${productId}?view=quickshop`)
        .then((response) => response.text())
        .then((html) => {
          const modalContent = document.querySelector(
            "#product-modal .modal-content",
          );
          modalContent.innerHTML = html;
          console.log("Modal content loaded");
          // Manually trigger initialization after modal content is loaded
          const event = new Event("content:loaded");
          document.dispatchEvent(event);
        })
        .catch((error) =>
          console.error("Error loading product modal content:", error),
        );
    }

    // Re-initialize selling plans widgets when content is loaded into the modal
    document.addEventListener("content:loaded", initializeSellingPlansWidgets);
  }
})();
